// extracted by mini-css-extract-plugin
export default {"wrapper":"Privacy_style_wrapper__HdaR8","content":"Privacy_style_content__TM9wH","rotate":"Privacy_style_rotate__yeCsf"};